<template>
  <div class="card">
    <div class="card-indicator skeleton" />
    <div class="card-body skeleton"></div>
  </div>
</template>

<style lang="scss" scoped>
.skeleton {
  background-color: #e2e5e7;
  background-image: linear-gradient(90deg, rgba(#fff, 0), rgba(#fff, 0.5), rgba(#fff, 0));
  background-size: 40px 100%;
  background-repeat: no-repeat;
  background-position: left -40px top 0;
  animation: shine 1s ease infinite;
}
.card {
  width: 20.75rem;
  height: 20.25rem;
  padding: 0.75rem;
}

.card-indicator {
  width: 19.25rem;
  height: 2rem;
  border-radius: 0.375rem;
  background-color: var(--bg-secondary);
  margin-bottom: 0.25rem;
}

.card-body {
  width: 19.25rem;
  height: 16.5rem;
  border-radius: 0.375rem;
  background-color: var(--bg-secondary);
}

@keyframes shine {
  to {
    background-position: right -40px top 0;
  }
}
</style>
